// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__jCq55","moreInfo":"TopMenu_moreInfo__Wu4fJ","logo":"TopMenu_logo__K1Ejw","menuTrigger":"TopMenu_menuTrigger__joKOz","closed":"TopMenu_closed__RkCK1"};